document.addEventListener('DOMContentLoaded', function() {

  const barSection = document.querySelector('.custom-announcement-bar-section');
  const slider = document.querySelector('.js-announcement-slider');
  const barItems = document.querySelectorAll('.js-bar-item');

  const drawer = document.querySelector('.custom-announcement-drawer');
  const overlay = document.querySelector('.custom-drawer-overlay');

  const tabTriggers = document.querySelectorAll('.js-tab-trigger');
  const tabContents = document.querySelectorAll('.js-tab-content');

  const closeBtns = document.querySelectorAll('.js-close-drawer');

  let slideTimer;
  let currentIndex = 0;

  /* =========================
     MOBILE/TABLET ARROWS
     ========================= */

  const prevArrow = document.createElement('button');
  prevArrow.className = 'custom-slider-arrow custom-slider-prev';

  prevArrow.innerHTML = `
    <svg viewBox="0 0 24 24" fill="none">
      <path d="M15 6L9 12L15 18"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"/>
    </svg>
  `;

  const nextArrow = document.createElement('button');
  nextArrow.className = 'custom-slider-arrow custom-slider-next';

  nextArrow.innerHTML = `
    <svg viewBox="0 0 24 24" fill="none">
      <path d="M9 6L15 12L9 18"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"/>
    </svg>
  `;

  barSection.appendChild(prevArrow);
  barSection.appendChild(nextArrow);

  function updateSlider(index) {

    slider.scrollTo({
      left: slider.offsetWidth * index,
      behavior: 'smooth'
    });
  }

  prevArrow.addEventListener('click', () => {

    stopAutoplay();

    currentIndex =
      currentIndex === 0
        ? barItems.length - 1
        : currentIndex - 1;

    updateSlider(currentIndex);

    startAutoplay();
  });

  nextArrow.addEventListener('click', () => {

    stopAutoplay();

    currentIndex =
      (currentIndex + 1) % barItems.length;

    updateSlider(currentIndex);

    startAutoplay();
  });

  /* =========================
     AUTOPLAY
     ========================= */

  function startAutoplay() {

    const isAutoslide =
      barSection.getAttribute('data-autoslide') === 'true';

    const intervalTime =
      parseInt(barSection.getAttribute('data-interval')) || 5000;

    if (
      window.innerWidth <= 1025 &&
      isAutoslide &&
      barItems.length > 1
    ) {

      clearInterval(slideTimer);

      slideTimer = setInterval(() => {

        currentIndex =
          (currentIndex + 1) % barItems.length;

        updateSlider(currentIndex);

      }, intervalTime);
    }
  }

  function stopAutoplay() {
    clearInterval(slideTimer);
  }

  /* =========================
     TABS
     ========================= */

  function switchTab(tabId) {

    tabTriggers.forEach(trigger => {

      trigger.classList.toggle(
        'is-active',
        trigger.dataset.tab === tabId
      );
    });

    tabContents.forEach(content => {

      content.classList.toggle(
        'is-active',
        content.id === tabId
      );
    });
  }

  /* =========================
     OPEN DRAWER
     ========================= */

  barItems.forEach((item, index) => {

    item.addEventListener('click', () => {

      currentIndex = index;

      stopAutoplay();

      const targetTab = item.dataset.targetTab;

      switchTab(targetTab);

      drawer.classList.add('is-active');
      overlay.classList.add('is-active');

      document.body.style.overflow = 'hidden';
    });
  });

  /* =========================
     TAB SWITCH
     ========================= */

  tabTriggers.forEach(trigger => {

    trigger.addEventListener('click', () => {

      switchTab(trigger.dataset.tab);
    });
  });

  /* =========================
     CLOSE DRAWER
     ========================= */

  closeBtns.forEach(btn => {

    btn.addEventListener('click', () => {

      drawer.classList.remove('is-active');
      overlay.classList.remove('is-active');

      document.body.style.overflow = '';

      startAutoplay();
    });
  });

  /* =========================
     TRACK SWIPE
     ========================= */

  slider.addEventListener('scroll', () => {

    if (window.innerWidth <= 1025) {

      currentIndex = Math.round(
        slider.scrollLeft / slider.offsetWidth
      );
    }
  });

  /* =========================
     INIT
     ========================= */

  startAutoplay();

  window.addEventListener('resize', () => {

    if (window.innerWidth > 1025) {

      stopAutoplay();

      slider.scrollTo({
        left: 0
      });

    } else {

      startAutoplay();
    }
  });
});